<bottomsheet-layout (dismiss)="closeBottomSheet()">
  <div class="tw-px-2">
    <div class="tw-flex tw-justify-center">
      <div class="tw-w-fit tw-relative">
        @if (data.productImage) {
          <img [src]="data.productImage" class="tw-w-30 tw-h-[150px] tw-object-contain tw-rounded-3" alt="product" />
        }
        <div class="tw-absolute tw-top-[10px] tw-right-0 tw-translate-x-1/2">
          <div class="tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-bg-gray-500 tw-rounded-full">
            <cs-icon class="tw-w-[14px] tw-h-[17px] tw-text-gray-500" [iconName]="'lock-icon-white'" />
          </div>
        </div>
      </div>
    </div>

    @if (data.type === LockedProductType.Repair) {
      <p class="tw-text-center tw-font-lexend tw-font-bold tw-text-700 tw-leading-[25px] tw-mt-4 tw-mb-2.5" i18n="@@lockedProductRepairTitle">Repair Is Available Only As Part Of A Kit</p>
      <p class="tw-font-body tw-text-300 tw-font-medium tw-text-gray-500 tw-text-center" i18n="@@lockedProductRepairDescription">Repair product is prescribed by a Cureskin doctor and is available only as part of your kit to ensure safe and effective use.</p>
    } @else {
      <p class="tw-text-center tw-font-lexend tw-font-bold tw-text-700 tw-leading-[25px] tw-mt-4 tw-mb-2.5" i18n="@@lockedProductUnavailableTitle">Not Available In Your Shop Yet</p>
      <p class="tw-font-body tw-text-300 tw-font-medium tw-text-gray-500 tw-text-center" i18n="@@lockedProductUnavailableDescription">Repair products are treatment-grade and prescribed by our doctors. They become available after your personalised consultation.</p>
    }
  </div>

  <div class="tw-mt-8">
    <button csButton
            (click)="onBuyKit()"
            class="tw-w-full tw-text-500 tw-font-semibold tw-max-w-full tw-m-0">
      <span i18n="@@lockedProductBuyFullKit">Buy Full Kit &#64;<span class="tw-line-through tw-font-normal tw-text-200">&#8377;{{ data.fixedPriceMRP }}</span> &#8377;{{ data.fixedPrice }}</span>
    </button>
  </div>
</bottomsheet-layout>
